export default "__VITE_ASSET__03153bcf__"